import api from "!../../../../common/temp/node_modules/.pnpm/style-loader@2.0.0_webpack@4.44.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../common/temp/node_modules/.pnpm/css-loader@5.2.7_webpack@4.44.2/node_modules/css-loader/dist/cjs.js!./bffButtonLink.css";

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



export default content.locals || {};